import React, { FC, PropsWithChildren } from 'react';
import { Grid } from '@mui/material';

const COLUMN_SIZES = [
  { xs: 12, sm: 6, lg: 2 },
  { xs: 12, sm: 6, lg: 4 },
  { xs: 12, sm: 6, lg: 2 },
  { xs: 12, sm: 6, lg: 4 },
];

export const KeyMetricsLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid
      container
      sx={{ m: 1 }}
      spacing={{ xs: 5, sm: 3, lg: 3 }}
      columns={12}
      my={{
        xs: 5,
        sm: 6,
      }}
    >
      {React.Children.map(children, (child, index) => (
        <Grid size={COLUMN_SIZES[index] || { xs: 12, sm: 6, lg: 3 }}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
};
